import { css } from "@emotion/css";

const styles = {
  btn: css`
    max-width: 100% !important;
  `,
};

export default styles;
